import { Component, inject, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserLoginService } from 'src/app/login/userlogin.service';
import { RoundoffSavingsService } from '../Interface & Service/round-off-savings/roundoff-savings.service';
import { RoundOffSaving, RoundOffSavingReadByUserIdRequest } from '../Interface & Service/round-off-savings/roundoff-savings.interface';

@Component({
  selector: 'app-roundup-savings',
  templateUrl: './round-off-transaction.component.html',
  styleUrls: ['./round-off-transaction.component.css']
})
export class RoundupOffTransactionComponent {
  User = inject(UserLoginService).User();
  roundOffService = inject(RoundoffSavingsService);
  modalService = inject(NgbModal);


  ngOnInit(): void {
    this.fetchRoundOffByUserIdRequest.userId = this.User?.userId
    this.FetchRoundOffDetailsForUser(this.fetchRoundOffByUserIdRequest)
  }
  fetchRoundOffByUserIdRequest: RoundOffSavingReadByUserIdRequest = {
    userId: this.User.userId
  }
  userRoundOffDetails: RoundOffSaving | null = null;
  isloading: boolean = false
  public FetchRoundOffDetailsForUser(requestDTO: RoundOffSavingReadByUserIdRequest) {
    this.isloading = true
    this.roundOffService.RoundOffSavings_ReadByUserId(requestDTO).subscribe({
      next: (res) => {
        this.isloading = false
        if (res) {
          this.userRoundOffDetails = res;
        } else {
          this.userRoundOffDetails = null;
        }
      },
      error: (err) => {
        console.error('Failed to fetch round-off details:', err);
        this.isloading = false
        this.userRoundOffDetails = null;
      }
    });
  }

  // Smart Vault Enroll Methods -----START
  @ViewChild('roundOffModal') roundOffModal!: TemplateRef<any>;
  public OpenSmartVaultModal() {
    this.modalService.open(this.roundOffModal, { size: 'lg', scrollable: true });
  }
  public HandleRoundOffEventEmit() {
    this.modalService.dismissAll();
    this.FetchRoundOffDetailsForUser(this.fetchRoundOffByUserIdRequest)
  }
  // Smart Vault Enroll Methods -----End
}